function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m496 184c0-63.472656-49.558594-115.449219-112-119.59375v-64.40625h-384v432h336v24c0 22.054688 17.945312 40 40 40s40-17.945312 40-40v-120h-16v-34.414062c54.703125-11.152344 96-59.632813 96-117.585938zm-16 0c0 57.34375-46.65625 104-104 104s-104-46.65625-104-104 46.65625-104 104-104 104 46.65625 104 104zm-144 152v80h-320v-400h352v48.40625c-62.441406 4.144531-112 56.121094-112 119.59375 0 57.953125 41.296875 106.433594 96 117.585938v34.414062zm64 120c0 13.230469-10.769531 24-24 24s-24-10.769531-24-24v-104h48zm-16-120h-16v-32.40625c2.65625.175781 5.296875.40625 8 .40625s5.34375-.230469 8-.40625zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m288 184c0 48.519531 39.480469 88 88 88s88-39.480469 88-88-39.480469-88-88-88-88 39.480469-88 88zm160 0c0 39.703125-32.304688 72-72 72s-72-32.296875-72-72 32.304688-72 72-72 72 32.296875 72 72zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m384 456c0 4.417969-3.582031 8-8 8s-8-3.582031-8-8 3.582031-8 8-8 8 3.582031 8 8zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m348.441406 201.34375-8.882812 13.3125 31.546875 21.023438 44.054687-88.105469-14.320312-7.148438-35.945313 71.894531zm0 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m143.382812 267.078125-14.765624-6.15625-11.28125 27.078125h-85.335938v112h128v-112h-25.335938zm.617188 36.921875v80h-96v-80h62.671875l-17.457031 41.894531-15.550782-15.550781-11.3125 11.3125 32.449219 32.449219 29.199219-70.105469zm0 0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m143.382812 115.078125-14.765624-6.15625-11.28125 27.078125h-85.335938v112h128v-112h-25.335938zm.617188 36.921875v80h-96v-80h62.671875l-17.457031 41.894531-15.550782-15.550781-11.3125 11.3125 32.449219 32.449219 29.199219-70.105469zm0 0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m224 64h16v16h-16zm0 0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m32 64h176v16h-176zm0 0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m176 288h96v16h-96zm0 0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m176 320h96v16h-96zm0 0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m176 352h96v16h-96zm0 0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m176 384h96v16h-96zm0 0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m176 136h64v16h-64zm0 0"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m176 168h64v16h-64zm0 0"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m176 200h64v16h-64zm0 0"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m176 232h64v16h-64zm0 0"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m32 32h208v16h-208zm0 0"
});

var SvgApproval = function SvgApproval(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "496pt",
    viewBox: "0 0 496 496",
    width: "496pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApproval, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/approval.a9919e14.svg";
export { ForwardRef as ReactComponent };